import { IonLoading, IonChip, IonList, IonBackButton, IonSearchbar, IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonAvatar, IonLabel, IonIcon, IonFabButton, IonFab } from '@ionic/react';
import React from 'react';
import Server from '../Server';
import '../styles/Discover.scss';
import PremiumDogoo from '../images/premium.png';
import Utilities from '../Utilities';
import LanguagePickerModal from './LanguagePicker';
import { americanFootball, closeCircle, desktop, download, flask, language, layers, person, school } from 'ionicons/icons';

import Blob1 from '../images/blob-1.svg';
import Blob2 from '../images/blob-2.svg';

class Discover extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
        sets: [],
        keywords: "",
        fullscreenLoading: false,
        allLangs: [],
        from: localStorage.getItem("lastFromSearchLang") || "",
        to: localStorage.getItem("lastToSearchLang") || "",
        languagePickerModal: null,
        users: [],
        showMore: [],
        showingSearchResults: false,
        searchResults: []
      }
  }

  async search() {
    if (!this.state.from && !this.state.to && !this.state.keywords.trim()) {
      window.toast(window.ln.keywordsOrLangNeeded, "info")
      return;
    }

    this.setState({
      fullscreenLoading: true
    })

    let res = await Server.searchPublicSets(this.state.keywords, this.state.from, this.state.to);
    Utilities.trackEvent("Discover", "Discover Search Sets", this.state.keywords + "|" + this.state.from + "|" + this.state.to);

    this.setState({
      showingSearchResults: true,
      searchResults: res || [],
      fullscreenLoading: false
    })
  }

  async componentDidMount() {
    Utilities.trackEvent("Discover", "Discover Page View");
    let category = this.props.match.params.category;
    this.setState({ fullscreenLoading: true });
    let data;
    if (category) {
      data = await Server.getTrendingPublicSets(this.state.from, category);
    } else {
      data = localStorage.getItem("trendingCache") ? JSON.parse(localStorage.getItem("trendingCache")) : null // await Server.getTrendingPublicSets(this.state.from, category);
    }
    if (!data) {
      this.setState({ fullscreenLoading: false });
      return;
    }
    let sets = data.sets
    let allLangs = [];
    if (sets && sets[0]) {
      for (let i = 0; i < sets.length; i++) {
        if (allLangs.indexOf(sets[i].term) === -1) {
          allLangs.push(sets[i].term)
        }
        if (allLangs.indexOf(sets[i].definition) === -1) {
          allLangs.push(sets[i].definition)
        }
      }

      // let wotd = data.wotd;

      // if (wotd) {
      //   let lastWotd = localStorage.getItem("wotd") ? JSON.parse(localStorage.getItem("wotd")) : null;
      //   if (lastWotd) {
      //     if (Utilities.formatDate(new Date(lastWotd.date), "YYYY-MM-DD") !== Utilities.formatDate(new Date(), "YYYY-MM-DD")) {
      //       localStorage.setItem("wotd", JSON.stringify({ date: Utilities.formatDate(new Date(), "YYYY-MM-DD"), data: wotd }))
      //     } else {
      //       wotd = lastWotd.data
      //     }
      //   } else {
      //     localStorage.setItem("wotd", JSON.stringify({ date: Utilities.formatDate(new Date(), "YYYY-MM-DD"), data: wotd }))
      //   }
      // }

      const metaDescription = data.description

      if (metaDescription) {
        Utilities.writeCustomMetaTags();
        document.title = Utilities.capitalize(category) + " Flashcards | Flashcards made Simple";
        let link = document.createElement('meta'); link.setAttribute('name', 'description');  link.content = metaDescription; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('property', 'og:type');  link.content = "article"; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('property', 'og:locale');  link.content = "en_US"; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('property', 'og:site_name');  link.content = "Flashcards made Simple"; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('property', 'og:title');  link.content = document.title; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('property', 'og:url');  link.content = window.location.href; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('property', 'og:description');  link.content = metaDescription; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('property', 'og:image');  link.content = "https://firebasestorage.googleapis.com/v0/b/simpleflashcardmanager.appspot.com/o/website%2Fcover-min.png?alt=media&token=f8b2b84b-14a1-43cf-aaba-13b482e54577"; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('name', 'twitter:title');  link.content = document.title; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('name', 'twitter:description');  link.content = metaDescription; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('name', 'twitter:card');  link.content = "summary_large_image"; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('name', 'twitter:url');  link.content = window.location.href; document.getElementsByTagName('head')[0].appendChild(link);
        link = document.createElement('meta'); link.setAttribute('name', 'twitter:image');  link.content = "https://firebasestorage.googleapis.com/v0/b/simpleflashcardmanager.appspot.com/o/website%2Fcover-min.png?alt=media&token=f8b2b84b-14a1-43cf-aaba-13b482e54577"; document.getElementsByTagName('head')[0].appendChild(link);
      } else {
        Utilities.writeDefaultMetaTags();
      }

      this.setState({
        sets: sets,
        fullscreenLoading: false,
        allLangs: this.state.allLangs.length === 0 ? allLangs : this.state.allLangs,
        category: category,
        categoryDescription: data.description,
        // wotd: wotd,
        users: data.users
      })
    } else {
      this.setState({
        sets: [],
        category: category,
        fullscreenLoading: false,
        categoryDescription: null,
        users: [],
        wotd: null
      })
    }
  }

  async open(setId) {
    Utilities.trackEvent("Discover", "Discover Open Set", setId)
    let set = await Server.getPublicSet(setId);
  }

  renderSet(set) {
    const termLang = this.state.from === set.definition ? set.term : set.definition;
    const defLang = this.state.from === set.definition ? set.definition : set.term;
    let termLangCode = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, termLang)
    let termCountryCode = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangCode].logo : null;
    let termCountryColor = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangCode].color : null;
    let defLangCode = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, defLang)
    let defCountryCode = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[defLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[defLangCode].logo : null;

    if (window.globalVars.AVAILABLE_FLAGS.indexOf(termCountryCode) === -1) {
      termCountryCode = "xx"
    }

    if (window.globalVars.AVAILABLE_FLAGS.indexOf(defCountryCode) === -1) {
      defCountryCode = "xx"
    }

    return (
      <div 
        className='set'
        onClick={() => {
          this.props.history.push("/set/" + set.viewSecret);
        }}
        style={{
          background: termCountryColor
        }}
      >
        <div className='info'>
          <h3>{set.name}</h3>
          <div className='lang-owner'>
            { (termCountryCode) &&
              <span>
                <img className="target" src={require('../images/flags/' + termCountryCode + '.svg')} />
                <span>{termLang}</span>
              </span>
            }
            { (defCountryCode && termCountryCode !== defCountryCode) &&
              <span>
                <img className="source" src={require('../images/flags/' + defCountryCode + '.svg')} />
                <span>{defLang}</span>
              </span>
            }
            { (set.owner && set.owner.image) &&
              <span>
                <img className="user" src={set.owner.image} />
                <span>by {set.owner.username}</span>
              </span>
            }
            <span>
              <label>
                <IonIcon icon={download} />
              </label>
              <span>{set.downloadedCount}</span>
            </span>
            <span>
              <label>
                <IonIcon icon={layers} />
              </label>
              <span>{set.cardCount}</span>
            </span>
          </div>
        </div>
      </div>
    )
  }

  render() {

    const categories = [
      {
        title: "Languages",
        sets: this.state.sets.filter(set => set.tags.indexOf("language") !== -1).sort(Utilities.dynamicSort("downloadedCount", -1)),
        icon: language,
        color: '#6E3CBC'
      },
      {
        title: "Science",
        sets: this.state.sets.filter(set => set.tags.indexOf("science") !== -1).sort(Utilities.dynamicSort("downloadedCount", -1)),
        icon: flask,
        color: '#617be3'
      },
      {
        title: "Computer Science",
        sets:  this.state.sets.filter(set => set.tags.indexOf("computer science") !== -1).sort(Utilities.dynamicSort("downloadedCount", -1)),
        icon: desktop,
        color: '#F9844A'
      },
      {
        title: "Sports",
        sets:  this.state.sets.filter(set => set.tags.indexOf("sport") !== -1).sort(Utilities.dynamicSort("downloadedCount", -1)),
        icon: americanFootball,
        color: '#50d890'
      },
      {
        title: "Social Sciences",
        sets:  this.state.sets.filter(set => set.tags.indexOf("social science") !== -1).sort(Utilities.dynamicSort("downloadedCount", -1)),
        icon: school,
        color: '#009DAE'
      }
    ]

    const totalResults = categories.map(item => item.sets.length).reduce((prev, next) => prev + next);
    const allLangs = ["I"]

    const tryRequire = (path) => {
      try {
       return require(path);
      } catch (err) {
        console.log(err)
       return null;
      }
    };

    console.log(this.state.allLangs)

    return (
      <IonPage data-page="help-guides">
        <IonHeader>
          <IonToolbar
            style={{
              height: 0,
              overflow: "hidden"
            }}
          >
            <IonTitle>{window.ln.discover}</IonTitle>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" text={window.ln.back} />
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent id="discover-content" fullscreen>
          {/* <div className="ig-wrapper">
            <div class="embedsocial-hashtag" data-ref="f0fd1214c1906ca152d296e672ffe6a7701b866c"></div>
          </div> */}
          <div className="search" onClick={(e) => {
            if (this.state.category) {
              e.preventDefault();
              this.props.history.push("/discover")
            }
          }}>
            <IonSearchbar
              debounce={700}
              id="search--bar"
              showCancelButton="focus"
              value={this.state.keywords}
              onIonChange={(e) => {
                  this.setState({
                      keywords: e.target.value.toLowerCase()
                  })
              }}
              placeholder={window.ln.searchAllSets}
            />
            <div className='language-pickers'>
              <div
                className='language-picker'
                onClick={() => {
                  this.setState({
                    languagePickerModal: "from"
                  })
                }}
              >
                { this.state.from ?
                  <img src={require('../images/flags/' + ((window.globalVars.AVAILABLE_FLAGS.indexOf(window.globalVars.LANGUAGES_CODES_TO_COUNTRY[Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.state.from)].logo) === -1) ? 'gb' : window.globalVars.LANGUAGES_CODES_TO_COUNTRY[Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.state.from)].logo ) + '.svg')} />
                  :
                  <img src={require('../images/flags/xx.svg')} />
                }
                <span>{this.state.from || (window.ln.anyLanguage)}</span>
              </div>
              <div
                className='language-picker'
                onClick={() => {
                  this.setState({
                    languagePickerModal: "to"
                  })
                }}
              >
                { this.state.to ?
                  <img src={require('../images/flags/' + ((window.globalVars.AVAILABLE_FLAGS.indexOf(window.globalVars.LANGUAGES_CODES_TO_COUNTRY[Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.state.to)].logo) === -1) ? 'gb' : window.globalVars.LANGUAGES_CODES_TO_COUNTRY[Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.state.to)].logo ) + '.svg')} />
                  :
                  <img src={require('../images/flags/xx.svg')} />
                }
                <span>{this.state.to || (window.ln.anyLanguage)}</span>
              </div>
            </div>
            <div className='clearfix' style={{ textAlign: 'center' }}>
              <button onClick={() => {
                this.search();
              }} className='main'>{window.ln.search}</button>
            </div>
          </div>
          <div className='header'>
            {/* <h1>{ this.state.category ? Utilities.capitalize(this.state.category) : "Trending" }</h1> */}
            {/* <div className='options'>
              { (!this.state.category) &&
                <div
                  className='language-picker'
                  onClick={() => {
                    this.setState({
                      languagePickerModal: true
                    })
                  }}
                >
                  <img src={require('../images/flags/' + ((window.globalVars.AVAILABLE_FLAGS.indexOf(window.globalVars.LANGUAGES_CODES_TO_COUNTRY[Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.state.from)].logo) === -1) ? 'gb' : window.globalVars.LANGUAGES_CODES_TO_COUNTRY[Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.state.from)].logo ) + '.svg')} />
                </div>
              }
          </div> */}
          { (!this.state.showSearch && this.state.wotd && !this.state.categoryDescription) &&
            <div 
              className='wotd'
              onClick={() => {
                this.setState({
                  showWotdDetails: !this.state.showWotdDetails
                })
              }}
            >
              { (!this.state.showWotdDetails) &&
                <blockquote>WORD OF THE DAY</blockquote>
              }
              <h3>
                {Utilities.capitalize(this.state.wotd.word)}
                <label>{this.state.wotd.type}</label>
              </h3>
              
              <div>
                { (this.state.showWotdDetails) && <h4>Meaning</h4> }
                { this.state.wotd.meaning.map((meaning, meaningI) => {
                  if (meaningI > 0 && !this.state.showWotdDetails)
                    return null;
                  return <p>{meaning}</p>
                }) }
              </div>

              { (!this.state.showWotdDetails) &&
                <button>{window.ln.showAll}</button>
              }

              { (this.state.showWotdDetails && this.state.wotd.examples && this.state.wotd.examples.length !== 0) &&
                <div>
                  <h4>Examples</h4>
                  { this.state.wotd.examples.map(examples => {
                    return <p>{examples}</p>
                  }) }
                </div>
              }

              { (this.state.showWotdDetails && this.state.wotd.details) &&
                <div>
                  <h4>Details</h4>
                  <p>{this.state.wotd.details}</p>
                </div>
              }
            </div>
          }
          {/* { (this.state.users && !this.state.categoryDescription && this.state.users.length !== 0) &&
            <section className='top-users'>
              <div
                className='section-head'
                style={{
                  background: '#009DAE'
                }}
              >
                <h2>Top Users</h2>
                <IonIcon icon={person} />
                <img 
                  src={Blob2} 
                  style={{
                    width: 220,
                    top: -73,
                    right: -100,
                  }}
                />
              </div>
              <div>
                { this.state.users.map(user => {
                  return (
                    <div
                      onClick={() => {
                        if (user.username === "chillnstudy") {
                          window.open("https://chillnstudy.com")
                        }
                      }}
                    >
                      <img src={user.image} />
                      <p>{user.username}</p>
                    </div>
                  )
                }) }
              </div>
            </section>
          } */}
          </div>
            {/* { (totalResults === 0 && !this.state.fullscreenLoading) &&
              <div className='no-results'>
                No results
              </div>
            } */}
            {/* { (totalResults === 0 && !this.state.fullscreenLoading) &&
              <div className="top-info premium">
                <div className="img">
                    <img src={PremiumDogoo} />
                </div>
                <div className="side">
                    <h2>{window.ln.noCardsQ}</h2>
                    <p>{window.ln.noCardsS}</p>
                    <button onClick={() => { this.props.history.push("/sets") }}>{window.ln.createOwn}</button>
                </div>
              </div>
            } */}
            { (this.state.categoryDescription) &&
              <h2
                className='category-description'
                style={{
                  padding: '18px 20px 0px 40px',
                  fontSize: '1.2em'
                }}
              >
                {this.state.categoryDescription}
              </h2>
            }
            { ((totalResults !== 0 || this.state.categoryDescription) && this.state.category) &&
              <div className='results'>
                <section
                  style={{
                    marginTop: 30
                  }}
                >
                  { this.state.sets.map(set => {
                    return this.renderSet(set)
                  }) }
                </section>
              </div>
            }
            { (this.state.showingSearchResults) &&
              <div className='search-results results'>
                <section>
                  { (this.state.searchResults.length === 0) &&
                    <div className='no-results'>
                      No results
                    </div>
                  }
                  { this.state.searchResults.map(set => {
                    return this.renderSet(set);
                  }) }
                </section>
              </div>
            }
            { (totalResults !== 0 && !this.state.category && !this.state.showingSearchResults) &&
              <div className='results'>
              { categories.map((category, categoryI) => {
                if (category.sets.length === 0)
                  return null;
                return (
                  <section>
                    <div
                      className='section-head'
                      style={{
                        background: category.color
                      }}
                    >
                      <h2 className='trending-header'>
                        <span>{window.ln.trendingIn}</span>
                        <span>{category.title}</span>
                      </h2>
                      <IonIcon icon={category.icon} />
                      <img 
                        src={categoryI % 2 === 0 ? Blob1 : Blob2 } 
                        style={categoryI % 2 === 0 ? {
                          width: 220,
                          top: -73,
                          right: -79,
                        } : {
                          width: 220,
                          top: -73,
                          right: -100,
                        }}
                      />
                    </div>
                    { category.sets.map((set, setI) => {

                      if (setI > 19 && !this.state.showMore[categoryI]) {
                        return null;
                      }

                      // if (this.state.keywords) {
                      //   if (
                      //     set.name.indexOf(this.state.keywords) !== -1 || 
                      //     set.term.toLowerCase().indexOf(this.state.keywords) !== -1 || 
                      //     set.definition.toLowerCase().indexOf(this.state.keywords) !== -1
                      //   ) {  } else {
                      //     return null;
                      //   }
                      // }

                      return this.renderSet(set)
                    }) }
                    { (!this.state.showMore[categoryI] && category.sets.length > 19) &&
                      <div className='show-more-btn-wrapper'>
                        <button className='main'  onClick={() => {
                          let showMore = this.state.showMore;
                          showMore[categoryI] = true;
                          this.setState({ showMore: showMore })
                        }}>{window.ln.showAll}</button>
                      </div>
                    }
                  </section>
                )
              }) }
            </div>
          }
          {/* <IonList>
            { (this.state.sets) && this.state.sets.map(set => {
              if (this.state.keywords && set.title.toLowerCase().indexOf(this.state.keywords) === -1)
                return null;
              return (
                <IonItem>

                  <IonLabel className="ion-text-wrap" onClick={() => {
                    this.props.history.push("/set/" + set.viewSecret);
                  }}>
                    <h2>{set.name} ({set.term === set.definition ? set.term : set.term + " - " + set.definition})</h2>
                    <h3>{set.cardCount} {window.ln.words}, {set.downloadedCount} {window.ln.downloads}</h3>
                    <p>By {set.owner ? set.owner.username : "_chillnstudy"}</p>
                      { (set.tags) &&
                        <div className="tags">
                          { set.tags.map(tag => {
                            return (
                              <IonChip>
                                {tag}
                              </IonChip>
                            )
                          }) }
                        </div>
                      }
                  </IonLabel>
                </IonItem>
              )
            }) }
          </IonList> */}
        </IonContent>
        <LanguagePickerModal
            isOpen={this.state.languagePickerModal !== null}
            selected={null}
            showTheseLanguages={this.state.allLangs}
            onSelect={async (lang) => {
                this.setState({
                  from: this.state.languagePickerModal === "from" ? lang : this.state.from,
                  to: this.state.languagePickerModal === "to" ? lang : this.state.to,
                  languagePickerModal: null
                })
                localStorage.setItem(this.state.languagePickerModal === "from" ? "lastFromSearchLang" : "lastToSearchLang", lang)
            }}
            presentingElement={this.state.pageRef ? this.state.pageRef : null}
            onDidDismiss={() => { this.setState({ languagePickerModal: null }) }}
        />
        <IonLoading
            isOpen={this.state.fullscreenLoading}
            message={window.ln.loading}
            duration={10000}
        />
        { (this.state.showingSearchResults) &&
          <IonFab vertical="bottom" horizontal="start" slot="fixed" style={{ width: "calc(100% - 20px)", display: "flex", justifyContent: "center", marginBottom: 10 }}>
            <IonFabButton style={{ width: 156, '--border-radius': '56px', '--background': '#fb5b5a' }} onClick={() => {
                this.setState({
                    showingSearchResults: false,
                    searchResults: []
                })
            }}>
                <IonIcon icon={closeCircle} />
                <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{window.ln.clearFilters}</IonLabel>
            </IonFabButton>
          </IonFab>
        }
      </IonPage>
    );
  }

};

export default Discover;
